module.exports = __webpack_public_path__ + "img/icon5.d8636c77.png";